import React from 'react';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import theme from '@jetshop/ui/utils/theme';

const Wrapper = styled('div')`
  margin-bottom: 1rem;
`;

const PostName = styled('h1')`
  font-weight: 600;
  line-height: normal;
  font-size: 1.75rem;
  margin-bottom: 10px;
`;

const BlogContent = styled('div')`
  p {
    line-height: 1.6;
    a {
      text-decoration: none;
      color: ${theme('colors.primary')};
    }

    strong {
      font-weight: ${theme('typo.fontWeightBold')};
    }

    img {
      max-width: 100%;
    }
  }
`;

const BlogHeader = ({ category }) => {
  const title = category.mainHeader || category.name;
  return (
    <Wrapper>
      <MaxWidth>
        <PostName data-testid="page-header">{title}</PostName>
        <BlogContent
          data-testid="blog-description"
          dangerouslySetInnerHTML={{
            __html: category.content
          }}
        />
      </MaxWidth>
    </Wrapper>
  );
};

export default BlogHeader;
